import { render, staticRenderFns } from "./dragCom.vue?vue&type=template&id=2adbe0ee&scoped=true"
import script from "./dragCom.vue?vue&type=script&lang=js"
export * from "./dragCom.vue?vue&type=script&lang=js"
import style0 from "./dragCom.vue?vue&type=style&index=0&id=2adbe0ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adbe0ee",
  null
  
)

export default component.exports